<template>
  <div>
    <vs-row vs-justify="left">
      <vs-col vs-align="center" vs-lg="6" vs-xs="6">
        <b-field label="Dispositivos *">
          <treeselect
              :options="devicesList"
              v-model="device"
              :disable-branch-nodes="true"
              :show-count="true"
              :multiple="true"
              name="device"
              v-validate="'required'"
              placeholder="Seleccione dispositivos "
              @select="selected"
              @deselect="deselected"
          />
        </b-field>
      </vs-col>
    </vs-row>

    <div class="column">

    </div>

    <div class="modal-footer">
      <div class="columns">
        <div class="column text-right">
          <vs-button
              color="danger"
              type="filled"
              @click="deleteMethod"
              style="margin-right: 10px">
            Eliminar método
          </vs-button>
          <vs-button color="primary" type="filled" @click="save">Guardar</vs-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import deviceEndpoint from "@/endpoints/core/DeviceEndpoint";
import DeviceEndpoint from "@/endpoints/machine/DeviceEndpoint";
import {get as getProp} from "object-path";

export default {
  name: "methodDetail",
  props: {
    companyId: Number,
    payMethod: Object
  },
  components: {},
  data() {
    return {
      devicesList: [],
      device: [],
      selectedDevice: null,
      selectedDeviceList: [],
      forceRender: 0
    };
  },

  mounted() {
    const params = {
      companyId : this.companyId
    }
    DeviceEndpoint.listPaymentDevices(params)
        .then(data => {
          this.devicesList = data;
        });
    this.forceRender++;
  },
  watch: {
    devicesList() {
      if (this.payMethod && this.payMethod.methodSettingDetailList
          && this.payMethod.methodSettingDetailList.length > 0) {
        this.payMethod.methodSettingDetailList.forEach(item => {
          this.device.push(item.device.code);
        });
      }
    }
  },
  methods: {
    save() {
      this.$emit("save");
    },
    selected(devices) {
      const deviceId = getProp(devices, "code");
      const device = {code: null, device: {code: deviceId}};
      this.selectedDeviceList.push(device);
      this.payMethod.methodSettingDetailList.push(device);
    },
    deselected(devices) {

      const indexDevice = this.payMethod.methodSettingDetailList.findIndex(
          (device) => device.device.code === devices.code);
      this.payMethod.methodSettingDetailList.splice(indexDevice, 1);
    },
    deleteMethod() {
      this.$emit("deleteMethod", this.payMethod);
    }
  }
}

</script>

<style>
</style>